export const MiningDiscoveryRewardsPanel = ({ discoveries, milestoneBusyKey, onClaimMilestone }) => {
  return (
    <section data-testid="mining-discovery-rewards-panel" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm space-y-4">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Discovery Rewards</h2>
          <p className="text-xs text-zinc-500 mt-1">Your finds now unlock recipes and milestone rewards.</p>
        </div>
        <div data-testid="mining-discovery-claimable-count" className="text-xs text-zinc-400">
          {discoveries?.claimable_count || 0} ready to claim
        </div>
      </div>

      <div className="grid xl:grid-cols-2 gap-4">
        {(discoveries?.entries || []).map((entry) => (
          <article key={entry.id} data-testid={`mining-discovery-reward-${entry.id}`} className="border border-zinc-800 bg-zinc-900/60 p-4 rounded-sm space-y-3">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-cinzel text-sm text-zinc-100">{entry.name}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1">Found {entry.count} time{entry.count === 1 ? "" : "s"}</div>
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-zinc-500">{entry.rarity}</div>
            </div>

            <div className="space-y-3">
              {(entry.milestones || []).map((milestone) => {
                const busy = milestoneBusyKey === `${entry.id}-${milestone.milestone}`;
                return (
                  <div key={`${entry.id}-${milestone.milestone}`} data-testid={`mining-milestone-${entry.id}-${milestone.milestone}`} className="border border-zinc-800 bg-zinc-950/50 p-3 rounded-sm">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <div className="text-xs text-zinc-100">{milestone.label}</div>
                        <div className="text-xs text-zinc-500 mt-1">{milestone.reward_summary}</div>
                      </div>
                      <div className="text-xs uppercase tracking-[0.18em] text-zinc-500">{milestone.progress}/{milestone.required}</div>
                    </div>
                    {milestone.unlock_material_name && (
                      <div className="mt-2 space-y-1">
                        <div className="text-xs uppercase tracking-[0.18em] text-amber-300">Unlocks: {milestone.unlock_material_name}</div>
                        {milestone.unlock_material_effect_summary && <div className="text-xs text-zinc-400">{milestone.unlock_material_effect_summary}</div>}
                      </div>
                    )}
                    {milestone.unlock_project_name && (
                      <div className="mt-1 space-y-1">
                        <div className="text-xs uppercase tracking-[0.18em] text-amber-300">Unlocks project: {milestone.unlock_project_name}</div>
                        {milestone.unlock_project_effect_summary && <div className="text-xs text-zinc-400">{milestone.unlock_project_effect_summary}</div>}
                      </div>
                    )}
                    {!!Object.keys(milestone.raw_ore_rewards || {}).length && (
                      <div className="mt-2 text-xs text-zinc-400">
                        Ore reward: {Object.entries(milestone.raw_ore_rewards).map(([rarity, amount]) => `${amount} ${rarity}`).join(" • ")}
                      </div>
                    )}
                    {!!Object.keys(milestone.material_rewards || {}).length && (
                      <div className="mt-1 text-xs text-zinc-400">
                        Material reward: {Object.entries(milestone.material_rewards).map(([materialId, amount]) => `${amount} ${materialId.replaceAll("_", " ")}`).join(" • ")}
                      </div>
                    )}

                    {milestone.claimed ? (
                      <div data-testid={`mining-milestone-claimed-${entry.id}-${milestone.milestone}`} className="mt-3 text-xs uppercase tracking-[0.18em] text-amber-300">Claimed</div>
                    ) : milestone.claimable ? (
                      <button
                        data-testid={`mining-milestone-claim-${entry.id}-${milestone.milestone}`}
                        onClick={() => onClaimMilestone(entry.id, milestone.milestone)}
                        disabled={busy}
                        className="mt-3 px-4 py-2 border border-amber-600 text-amber-300 hover:bg-amber-950/20 rounded-sm text-xs font-cinzel uppercase tracking-[0.18em] disabled:opacity-50"
                      >
                        {busy ? "Claiming" : "Claim Reward"}
                      </button>
                    ) : (
                      <div className="mt-3 text-xs uppercase tracking-[0.18em] text-zinc-500">Keep mining to unlock this reward</div>
                    )}
                  </div>
                );
              })}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};